// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-green{background:#5ecf3f !important}.bg-premier-blue{background:#404040 !important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
